/**
 * Seletor de idioma.
 *
 * Só aparece quando há mais de um idioma habilitado. No piloto, `pt-BR` é o
 * único aprovado — e um seletor com uma opção só é ruído numa tela pequena.
 */

import { useTranslation } from 'react-i18next';

import { ENABLED_LOCALES, changeLocale, type Locale } from '@/i18n';

const LABELS: Record<Locale, string> = {
  // Cada idioma escrito no próprio idioma: quem procura espanhol reconhece
  // "Español" mesmo sem entender a interface em que o seletor está.
  'pt-BR': 'Português',
  'en-US': 'English',
  'es-419': 'Español',
};

export function LocalePicker() {
  const { t, i18n } = useTranslation(['common']);

  if (ENABLED_LOCALES.length < 2) return null;

  return (
    <label className="flex items-center gap-1 text-sm">
      <span className="mh-sr-only">{t('common:settings.language')}</span>
      <select
        value={i18n.language}
        onChange={(event) => void changeLocale(event.target.value as Locale)}
        className="min-h-(--tap-target) rounded-full border border-(--color-sand-300) bg-(--color-sand-0) px-3"
      >
        {ENABLED_LOCALES.map((locale) => (
          <option key={locale} value={locale}>
            {LABELS[locale]}
          </option>
        ))}
      </select>
    </label>
  );
}
